export default {
  namespaced: true,
  state: {
    subjectName: ''
  },
  getters: {
    getSubjectName (state) {
      return state.subjectName
    }
  },
  mutations: {
    setSubjectName (state, subjectName) {
      state.subjectName = subjectName
    }
  }
}
